
import ArticleCard from '~/components/shared/ArticleCard'
export default {
  name: 'RelatedBlogPostsComponent',
  components: { ArticleCard },
  props: {
    postid: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    relatedPosts: [],
  }),
  async fetch() {
    await this.$axios
      .$get(
        `https://api.plantssogood.com/wp-json/psg/v1/posts/related/${this.postid}`
      )
      .then((res) => {
        this.relatedPosts = res
      })
  },
}
